<div class="modal-body content width-500 ">
	<div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getRessource('Header')}}
    </span>
		<div class="content">
			<exg-input [(ngModel)]="dataModelClone.qcfgName"
			           [caption]="'Konfigurationsname'"
			           class="">
			</exg-input>
			<exg-switch [(ngModel)]="dataModelClone.qcfgIsDraft"
			            caption="Entwurf">
			</exg-switch>
		</div>
		<div class="spawn-modal-actions typo-small">
			<button (click)="delete()" class="md-btn"
			        *ngIf="dataModelClone?.qcnfID">
				{{getGlobal('Delete')}}
			</button>
			<button (click)="cancel()" class="md-btn">
				{{getGlobal('Cancel')}}
			</button>
			<button (click)="save()"
			        class="md-btn">
				{{getGlobal('Create')}}
			</button>
		</div>
	</div>
</div>
